<template>
  <div class="popup_in">
    <div class="popup">
      <div class="popup_close close-animate">
        <a href="javascript:void(0);" @click.prevent="onCancel">
          <CloseSvg />
        </a>
      </div>
      <div class="ic-ok mb-15"><okSvg /></div>
      <div class="title title--55 bold">
        בלוק מרפאה נוצר בהצלחה!
      </div>
      <div class="title--32 ft--300" style="display:none">
        לאחר אישורך, בלוק המרפאה יפתח לקביעת תורים באמצעות מוקד זימון התורים
        והזימון הדיגיטלי.
      </div>
    </div>
  </div>
</template>

<script>
import okSvg from "../../assets/img/svg/ok.svg";
import CloseSvg from "@/assets/img/svg/close.svg";
import { getHash } from "../../utilities/hash.js";

export default {
  name: "ConfirmNewBlock",
  props: ["date"],
  methods: {
    async onCancel() {
      const date = this.$moment(this.date).format("YYYY-MM-DD");
      const hash = getHash({ date: date, view: "day" });
      await this.$router.push(`/dashboard#${hash}`);
      this.$emit("close");
    }
  },
  components: {
    okSvg,
    CloseSvg
  }
};
</script>
